"use client";
import Button from "@/components/primitives/button";

export default function ErrorBoundary() {
  return (
    <div
      className="w-full bg-cover bg-center flex flex-col justify-start items-center gap-14 pt-20 pb-80 -mb-16 min-h-[80vh]"
      style={{
        backgroundImage: "url(/images/ui/404.webp)",
      }}
    >
      <div>
        <svg
          width="372"
          height="107"
          viewBox="0 0 372 107"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g style={{ mixBlendMode: "screen" }} filter="url(#filter0_f_6_355)">
            <path d="M348 81L24 81" stroke="#AEE449" strokeWidth="2" />
          </g>
          <g style={{ mixBlendMode: "screen" }} filter="url(#filter1_f_6_355)">
            <path d="M348 81L24 81" stroke="#AEE449" strokeWidth="2" />
          </g>
          <g style={{ mixBlendMode: "screen" }} filter="url(#filter2_dd_6_355)">
            <path d="M348 81L24 81" stroke="#AEE449" strokeWidth="2" />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M266.957 24.8369L265.305 31.2566L275.135 31.2566L276.787 24.8369L266.957 24.8369Z"
            fill="#B1ED40"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M288.521 31.2564L301.733 31.2564L313.612 31.2564L313.941 29.9722C314.083 29.3223 313.995 28.6889 313.678 28.0727C313.361 27.4565 312.894 26.9088 312.277 26.4284C311.66 25.9496 310.947 25.5642 310.137 25.2734C309.326 24.983 308.499 24.8369 307.653 24.8369L280.383 24.8369L278.73 31.2566L288.521 31.2564Z"
            fill="#B1ED40"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M329.24 31.2566L329.268 31.2566L349.034 31.2566L350.724 24.8369L326.466 24.8369C325.657 24.8369 324.757 24.983 323.772 25.2734C322.784 25.5642 321.86 25.9496 320.997 26.4284C320.134 26.9088 319.376 27.4565 318.724 28.0727C318.072 28.6889 317.676 29.3223 317.535 29.9722L317.205 31.2564L329.24 31.2566Z"
            fill="#B1ED40"
          />
          <path
            d="M78.1749 28.0729C77.8579 27.4567 77.3905 26.9089 76.7741 26.4286C76.1581 25.9497 75.4445 25.5644 74.6338 25.2736C73.8235 24.9831 72.9959 24.8371 72.1499 24.8371L31.8785 24.8371L23.9512 55.6515L33.7808 55.6515L40.0167 31.2568L49.2133 31.2568L42.9768 55.6515L52.8068 55.6515L59.0434 31.2568L66.2303 31.2568C66.724 31.2914 67.1469 31.4537 67.4989 31.7451C67.8513 32.0355 67.9395 32.5238 67.7637 33.2087L62.0027 55.6515L71.8328 55.6515L78.4387 29.9726C78.58 29.3225 78.492 28.6893 78.1749 28.0729ZM116.65 28.0729C116.333 27.4567 115.866 26.9089 115.249 26.4286C114.632 25.9497 113.919 25.5644 113.109 25.2736C112.299 24.9831 111.471 24.8371 110.625 24.8371L90.9648 24.8371C90.1549 24.8371 89.2556 24.9831 88.2695 25.2736C87.283 25.5644 86.3586 25.9497 85.4951 26.4286C84.6317 26.9089 83.8739 27.4567 83.2225 28.0729C82.5707 28.6891 82.1743 29.3225 82.0329 29.9724L76.748 50.5155C76.5718 51.1663 76.6512 51.7998 76.9861 52.4158C77.3213 53.032 77.7968 53.5799 78.4128 54.0593C79.0296 54.5391 79.7519 54.9243 80.5799 55.2143C81.408 55.5057 82.227 55.6513 83.0377 55.6513L102.697 55.6513C103.544 55.6513 104.45 55.5057 105.419 55.2143C106.388 54.9243 107.304 54.5391 108.168 54.0593C109.031 53.5799 109.779 53.032 110.413 52.4158C111.048 51.7998 111.453 51.1663 111.629 50.5155L116.914 29.9724C117.055 29.3225 116.967 28.6893 116.65 28.0729ZM106.238 33.2087L102.645 47.2799C102.468 47.965 102.125 48.4537 101.614 48.7435C101.103 49.0349 100.601 49.1978 100.108 49.2322L89.1678 49.2322C88.5691 49.2322 88.0754 49.095 87.688 48.8209C87.3009 48.5471 87.212 48.0337 87.4236 47.2799L91.017 33.2087C91.1936 32.4553 91.5456 31.9415 92.0744 31.6683C92.6026 31.394 93.1668 31.2568 93.7655 31.2568L104.705 31.2568C105.198 31.2914 105.622 31.4537 105.974 31.7451C106.326 32.0355 106.415 32.5236 106.238 33.2087ZM155.125 28.0729C154.808 27.4567 154.341 26.9089 153.724 26.4286C153.107 25.9497 152.394 25.5644 151.584 25.2736C150.773 24.9831 149.946 24.8371 149.1 24.8371L121.829 24.8371L113.902 55.6515L123.732 55.6515L129.967 31.2568L143.18 31.2568C143.674 31.2914 144.097 31.4537 144.449 31.7451C144.801 32.0355 144.889 32.5238 144.713 33.2087L138.953 55.6515L148.783 55.6515L155.389 29.9726C155.53 29.3225 155.442 28.6893 155.125 28.0729ZM165.325 43.4283L187.363 43.4283L189.055 37.0086L167.016 37.0086L167.967 33.2085C168.144 32.4551 168.496 31.9413 169.024 31.6681C169.553 31.3938 170.117 31.2566 170.716 31.2566L190.482 31.2566L192.173 24.8369L167.915 24.8369C167.105 24.8369 166.206 24.983 165.219 25.2734C164.233 25.5642 163.308 25.9496 162.445 26.4284C161.582 26.9088 160.824 27.4565 160.172 28.0727C159.521 28.6889 159.124 29.3223 158.983 29.9722L153.698 50.5153C153.522 51.1661 153.601 51.7996 153.936 52.4156C154.271 53.0318 154.746 53.5797 155.362 54.0591C155.979 54.5389 156.702 54.9241 157.53 55.2141C158.357 55.5055 159.177 55.6512 159.987 55.6512L184.245 55.6512L185.884 49.2316L166.118 49.2316C165.519 49.2316 165.025 49.0945 164.638 48.8204C164.251 48.5466 164.162 48.0331 164.374 47.2794L165.325 43.4283ZM218.862 24.8371L215.744 37.0088L204.751 37.0088C204.153 37.0088 203.659 36.872 203.271 36.5983C202.884 36.3241 202.778 35.8103 202.954 35.0573L205.597 24.8371L195.767 24.8371L192.279 38.2931C192.102 38.9433 192.181 39.5764 192.517 40.1926C192.852 40.8088 193.327 41.3565 193.944 41.8368C194.56 42.3157 195.283 42.7011 196.11 42.9919C196.939 43.2823 197.757 43.4283 198.568 43.4283L214.054 43.4283L213.102 47.2798C212.89 48.0335 212.52 48.547 211.992 48.8207C211.464 49.0947 210.9 49.232 210.301 49.232L189.478 49.232L187.84 55.6515L213.154 55.6515C213.965 55.6515 214.855 55.5059 215.823 55.2145C216.792 54.9245 217.717 54.5393 218.598 54.0595C219.479 53.5801 220.237 53.0322 220.871 52.416C221.505 51.7999 221.91 51.1665 222.086 50.5157L228.692 24.8371L218.862 24.8371ZM236.62 48.8207C236.233 48.547 236.144 48.0335 236.356 47.2798L242.117 24.8371L232.287 24.8371L225.68 50.5157C225.504 51.1665 225.583 51.7999 225.917 52.416C226.253 53.0322 226.729 53.5801 227.344 54.0595C227.961 54.5393 228.684 54.9245 229.512 55.2145C230.34 55.5059 231.158 55.6515 231.969 55.6515L255.434 55.6515L257.073 49.232L238.1 49.232C237.501 49.232 237.007 49.0949 236.62 48.8207ZM263.825 37.0088L259.029 55.6515L268.859 55.6515L273.655 37.0088L263.825 37.0088ZM272.453 55.6515L282.282 55.6515L287.047 37.0088L277.248 37.0088L272.453 55.6515ZM297.503 55.6515L307.333 55.6515L312.129 37.0088L302.288 37.0088L297.503 55.6515ZM323.876 43.4283L345.914 43.4283L347.606 37.0086L315.723 37.0086L312.248 50.5155C312.072 51.1663 312.151 51.7998 312.486 52.4158C312.821 53.032 313.296 53.5799 313.912 54.0593C314.529 54.5391 315.252 54.9243 316.08 55.2143C316.908 55.5057 317.727 55.6513 318.537 55.6513L342.795 55.6513L344.434 49.2318L324.668 49.2318C324.069 49.2318 323.576 49.0947 323.188 48.8205C322.801 48.5468 322.713 48.0333 322.924 47.2796L323.876 43.4283Z"
            fill="white"
          />
          <defs>
            <filter
              id="filter0_f_6_355"
              x="16"
              y="72"
              width="340"
              height="18"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="4"
                result="effect1_foregroundBlur_6_355"
              />
            </filter>
            <filter
              id="filter1_f_6_355"
              x="0"
              y="56"
              width="372"
              height="50"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="12"
                result="effect1_foregroundBlur_6_355"
              />
            </filter>
            <filter
              id="filter2_dd_6_355"
              x="1"
              y="59"
              width="370"
              height="48"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="11.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.576975 0 0 0 0 0.883333 0 0 0 0 0 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6_355"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="2" />
              <feGaussianBlur stdDeviation="4" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.576975 0 0 0 0 0.883333 0 0 0 0 0 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_dropShadow_6_355"
                result="effect2_dropShadow_6_355"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect2_dropShadow_6_355"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <div className="flex flex-col gap-4 uppercase text-surface-700 items-center text-center">
        <div className="text-display-lg">Sorry, sport!</div>
        <div className="text-headline-lg">An error has occurred</div>
      </div>
      <div className="flex gap-2 items-center">
        <Button onClick={() => window.location.href = "/"}>Moneyline Home</Button>

        {/* <Button href="/">Moneyline Home</Button> */}
      </div>
    </div>
  );
}
